import { useState, type ReactElement } from 'react';
import { useConfig, useNavigate, useServices, useSession, useT } from '../../../app/di';
import { Button } from '../../../ui-kit/Button/Button';
import { Dialog } from '../../../ui-kit/Dialog/Dialog';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { BlogForm } from './BlogForm/BlogForm';
import { BlogList } from './BlogList/BlogList';
import { newBlogValues } from './model/blog-form';

// WS-UC-1, WS-UC-2
export function BlogsPage(): ReactElement {
  const { t } = useT();
  const { me } = useSession();
  const [creating, setCreating] = useState(false);
  const create = (
    <Button variant="primary" icon="plus" onClick={() => setCreating(true)}>
      {t('workspaces.blogs.create')}
    </Button>
  );
  return (
    <div className="u-stack-lg">
      <PageHeader title={t('workspaces.blogs.title')} subtitle={t('workspaces.blogs.subtitle')} actions={create} />
      <BlogList blogs={me?.blogs ?? []} emptyAction={create} />
      {creating ? <CreateBlogDialog onClose={() => setCreating(false)} /> : null}
    </div>
  );
}

function CreateBlogDialog({ onClose }: { onClose(): void }): ReactElement {
  const { api, session } = useServices();
  const { ui } = useConfig();
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <Dialog
      open
      title={t('workspaces.blogs.create')}
      closeLabel={t('common.close')}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>{t('common.cancel')}</Button>
          <Button type="submit" form="create-blog" variant="primary">
            {t('common.create')}
          </Button>
        </>
      }
    >
      <BlogForm
        id="create-blog"
        initial={newBlogValues()}
        timeZonePageSize={ui.timeZones.pageSize}
        onSubmit={async (values) => {
          const result = await api.workspaces.create(values);
          if (result.success) {
            await session.refresh();
            onClose();
            navigate('posts', { blogId: result.data.id });
          }
          return result;
        }}
      />
    </Dialog>
  );
}
